import React from "react";

const SearchIcon = () => {
  return (
    <svg
      className="search-icon icon"
      viewBox="0 0 16 16"
      fill="none"
      width="14"
      height="14"
    >
      <circle
        cx="6.5"
        cy="6.5"
        r="4.5"
        stroke="#555555"
        strokeWidth="1.2"
      ></circle>
      <line
        x1="10"
        y1="10"
        x2="14"
        y2="14"
        stroke="#555555"
        strokeWidth="1.4"
        strokeLinecap="round"
      ></line>
    </svg>
  );
};

export default SearchIcon;
